<form fxFill [formGroup]="calendarForm">
  <calendar-form-input fxFill #calendarEditor formControlName="calendar" [config]="config" [showSideSteps]="_showSideSteps"></calendar-form-input>
</form>
